import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appResizeHandle]'
})
export class ResizeHandleDirective {
  @Input() public min = 0;
  @Input() public max = 0;
  @Input() public width = 0;
  @Output() public widthChange = new EventEmitter<number>();

  private active = false;

  private start = {
    x: 0,
    y: 0
  };

  constructor() {}

  @HostListener('mousedown', ['$event'])
  public mousedown(e: MouseEvent) {
    this.active = true;

    this.start.x = e.clientX;
    this.start.y = e.clientY;

    e.preventDefault();
  }

  @HostListener('window:mousemove', ['$event'])
  public mousemove(e: MouseEvent) {
    if (!this.active) {
      return;
    }

    let newWidth = this.width + e.clientX - this.start.x;
    if (newWidth > this.max) {
      newWidth = this.max;
    }
    if (newWidth < this.min) {
      newWidth = this.min;
    }
    if (newWidth != this.width) {
      this.widthChange.next(newWidth);
      this.start.x = e.clientX;
      this.start.y = e.clientY;
    }

    e.preventDefault();
  }

  @HostListener('window:mouseup', ['$event'])
  public mouseup(e: MouseEvent) {
    this.active = false;
    e.preventDefault();
  }
}
